import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { CommonService } from '../../../../core/services/common.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { StatePersistingService } from '../../../../core/services/state-persisting.service';
import { UserService } from '../../../../core/services/user.service';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../../core/common';
import { FreightClaimHeader, IGetOrdersInquiryBody, IOrderInquiry, IOrderInquiryLbl } from '../../../../core/models';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { OrderService } from '../../../../core/services/order.service';
import { FreightClaimService } from '../../../../core/services/freight-claim.service';

@Component({
  selector: 'app-claim-history',
  templateUrl: './claim-history.component.html',
  styleUrls: ['./claim-history.component.scss']
})
export class ClaimHistoryComponent implements OnInit {
  public gridData: FreightClaimHeader[] = [];
  toDate: Date = new Date();
  fromDate: Date = new Date(this.toDate.getFullYear() - 1, this.toDate.getMonth(), this.toDate.getDay());//last 60 days
  orderSelectionGridData: GridDataResult;
  loadingPDF: boolean = false;
  loadingExcel: boolean = false;
  orderLoading: boolean = false;
  loadingClaims: boolean = false;
  constructor(
    private orderService: OrderService,
    private freightClaimService: FreightClaimService,
    private commonService: CommonService,
    private persistingService: StatePersistingService,
    private languageTranslationService: LanguageTranslationService,
    private router: Router,
    private userService: UserService,
    private appNotifyService: AppNotifyService,) { }

  ngOnInit() {
    this.fillClaimHistoryGrid();
  }

  //#region Grid Data Load
  public fillClaimHistoryGrid(): void {
    this.loadingClaims = true;
    this.freightClaimService.getMyClaims().subscribe((response: Array<FreightClaimHeader>) => {
      this.gridData = response.map((obj) => {
        obj.raisedOn = obj.raisedOn ? new Date(obj.raisedOn) : null;
        // obj.scheduleDateAsDate = obj.scheduleDateUIString == "Pending" ? null : new Date(obj.scheduleDateUIString);
        return obj;
      },
        (error) => {
          this.loadingClaims = false;
        }
      );
      this.loadOrderGridData();
      this.loadingClaims = false;;

    })
  }

  public loadOrderGridData(): void {
    if (this.gridSettings.state) {
      this.orderSelectionGridData = process(this.gridData, this.gridSettings.state);
    }
    else {
      this.orderSelectionGridData = process(this.gridData, this.orderGridstate);
    }
    this.gridSettings.gridData = this.orderSelectionGridData;
  }

  //#endregion

  //#region label declaration
  public orderlblText: IOrderInquiryLbl = {
    jobNamelbl: 'Job Name',
    jobNumberlbl: 'Job Number',
    kdReflbl: 'KD Ref#',
    orderDatelbl: 'Order Date',
    orderTypeLbl: 'Order Type',
    orderNumberlbl: 'Order #',
    polbl: 'PO #',
    scheduleDatelbl: 'Schedule Date',
    shipFromlbl: 'Ship From',
    shipTolbl: 'Shipt To',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',
  }
  public orderSelectionGridLbl = {
    orderNumberlbl: 'Order #',
    orderTypeLbl: 'Order Type',
    orderDatelbl: 'Order Date',
    scheduleDatelbl: 'Schedule Date',
    jobNamelbl: 'Job Name',
    jobNumberlbl: 'Job Number',
    kdReflbl: 'KD Ref#',
    polbl: 'PO #',
    shipFromlbl: 'Ship From',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',

  };
  //#endregion

  //#region pagination, sorting,filtering for order grid
  public orderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'claimNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public gridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.gridData, this.orderGridstate),
    columnsConfig: [
      {
        field: 'claimNumber',
        title: 'Claim #',//this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderSelectionGridLbl.orderNumberlbl,
        filterable: true

      },
      {
        field: 'soNumber',
        title: this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderSelectionGridLbl.orderNumberlbl,
        filterable: true

      }, {
        field: 'orderType',
        title: this.orderlblText.orderTypeLbl ? this.orderlblText.orderTypeLbl : this.orderSelectionGridLbl.orderTypeLbl,
        filterable: true
      }, {
        field: 'raisedOn',
        title: 'Claim Date',//this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderSelectionGridLbl.orderDatelbl,
        filter: 'date',
        format: '{0:d}',//not able to get from and to
        _width: 240,
        filterable: true
      }, {
        field: 'statusName',
        title: 'Claim Status',//this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderSelectionGridLbl.jobNamelbl,
        filterable: true
      }, {
        field: 'jobName',
        title: this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderSelectionGridLbl.jobNamelbl,
        filterable: true
      }, {
        field: 'jobNumber',
        title: this.orderlblText.jobNumberlbl ? this.orderlblText.jobNumberlbl : this.orderSelectionGridLbl.jobNumberlbl,
        filterable: true
      }, {
        field: 'poNumber',
        title: this.orderlblText.polbl ? this.orderlblText.polbl : this.orderSelectionGridLbl.polbl,
        filterable: true
      },
      {
        field: 'shipFrom',
        title: this.orderlblText.shipFromlbl ? this.orderlblText.shipFromlbl : this.orderSelectionGridLbl.shipFromlbl,
        filterable: true
      },
      //{
      //  field: 'kdReference',
      //  title: this.orderlblText.kdReflbl ? this.orderlblText.kdReflbl : this.orderSelectionGridLbl.kdReflbl,
      //  filterable: true
      //}
    ]
  };

  public orderGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.loadOrderGridData();
  }

  public orderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.loadOrderGridData();
  }
  //when older date from fromDate and later date from toDate is selected
  //api call would be made or else filter would happen clientside
  public orderDataStateChange(state: DataStateChangeEvent): void {
    this.orderGridstate = state;
    this.gridSettings.state = this.orderGridstate;
    this.loadOrderGridData();
  }
  //#endregion

  //#region Export
  generateExcel() { }
  generatePDF() { }
  //#endregion

  proceedToMyClaimDetails(dataItem) {
    this.freightClaimService.claimHeaderId = dataItem.claimHeaderId;
    this.router.navigate(['/self-service/claim-history/view-claim/' + dataItem.claimNumber]);
  }

}
